var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReload = function SvgReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.78 8.375A1 1 0 0 0 15 8a.935.935 0 0 0-1 .765A6 6 0 0 1 8.035 14H8a6 6 0 1 1 4.225-10.245l-1.54 1.535c-.4.4-.27.71.28.71H15.5a.5.5 0 0 0 .5-.5V1c0-.55-.32-.685-.71-.3l-1.645 1.64A8 8 0 1 0 8 16h.035A8 8 0 0 0 16 9.22a1 1 0 0 0-.22-.845Z"
  })));
};
export default SvgReload;